<div
  id="dropContainer"
  (click)="openFileDialog()"
  (dragover)="onDragOver($event)"
  (drop)="onDrop($event)"
  [escape]="false"
  [tooltipDisabled]="!isGoogleRsaSearch"
  pTooltip="Image rules:<br/>1) JPG or PNG images<br/>2) Maximum file size 5120 KB<br/>3) Ratio 1x1 or 1.91x1 (within ~2% tolerance)<br/>4) Minimum pixels 300x300 (square) or 600x314 (landscape)"
  tooltipPosition="right"
>
  <span *ngIf="!imageSrc" class="m-1">Click inside or drop an image</span>
  <img
    *ngIf="imageSrc && imageSrc !== ''"
    [src]="imageSrc"
    alt="Image preview"
  />
</div>
<div class="image-upload-inline-error" *ngIf="uploadError">{{ uploadError }}</div>

<input
  #fileInput
  type="file"
  accept="image/jpg, image/jpeg, image/png, image/gif, image/bmp, image/tif, image/tiff"
  style="display: none"
  (change)="onClickForwardFile($event)"
/>
